import React from "react";

export default ({ children }) => (
  <div style={{ color: 'black', textTransform: 'uppercase', textAlign: 'center' }}>{children}</div>
);



// WEBPACK FOOTER //
// ./src/components/titre-axe.js